<template>
  <div>&nbsp;</div>
</template>
<script>
import vas from "@/lib/VASClient"

var config = require('../../../variants/' + BUILD_VARIANT + '/config.js').default;

export default {
  created() {
    var self = this;
    vas.freeLogin(this.$router.cellphone, this.$router.name).then(function (response) {
      if (response.status) {
        self.$store.commit('auth/login', {
          user: response.user,
          remember: true,
          name: self.name
        });
        self.$router.push('/dashboard')
      } else {
        self.showError = true;
        self.errorMessage = response.msg;
      }

      Loading.hide();
    }).catch(function (response) {
      self.showError = true;
      self.errorMessage = 'An error has occurred. Please try again later';
      // self.errorMessage = JSON.stringify(response);

      Loading.hide();
    });
  }
}
</script>
